import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'renci-form-validation',
  templateUrl: './form-validation.component.html',
  styleUrls: ['./form-validation.component.scss'],
})
export class FormValidationComponent implements OnInit, OnDestroy {
  @Input() messages;

  errors = [];

  private formChange$: Subscription;

  constructor(private controlContainer: FormGroupDirective) {}

  ngOnInit() {
    this.updateErrors(this.controlContainer.status);
    this.formChange$ = this.controlContainer.statusChanges.subscribe((status) => {
      this.updateErrors(status);
    });
  }

  ngOnDestroy() {
    this.formChange$.unsubscribe();
  }

  private updateErrors(status: string) {
    this.errors = [];
    if (status === 'INVALID') {
      if (this.controlContainer.form.errors) {
        for (const errorKey of Object.keys(this.controlContainer.form.errors)) {
          if (this.messages && this.messages[errorKey]) {
            this.errors.push(this.messages[errorKey]);
          } else {
            this.errors.push(...this.controlContainer.form.errors[errorKey].flat());
          }
        }
      }
    }
  }
}
